export default "__VITE_ASSET__DH52YNkc__"